import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from 'lib'
import { Response } from 'services/api/types'

type LoadOrderReservationsParams = {
  customerId?: string
}

const loadOrderReservations = (
  params: LoadOrderReservationsParams
): Response<any> => {
  return axios.get('/orders/reservations', {
    params: {
      customerId: params.customerId
    }
  })
}

export function useLoadOrderReservations(params: LoadOrderReservationsParams) {
  const { customerId } = params

  return useQuery(
    ['orderReservations', params],
    () => loadOrderReservations(params),
    {
      enabled: !!customerId,
      onError: () =>
        toast.error('Não foi possível carregar os pedidos de reserva', {
          toastId: 'loadOrderReservations'
        })
    }
  )
}
